import Splide from "@splidejs/splide";
import '@splidejs/splide/dist/css/themes/splide-default.min.css';

export default class SliderOnlyMobile {
  constructor() {
    this.setVars()
  }
  
  setVars() {
    this.settings = {
      init: 'data-slider-mobile',
      list: 'data-slider-mobile-list',
      item: 'data-slider-mobile-item'
    };
  
    
    this.sliders = document.querySelectorAll(`[${this.settings.init}]`);
    if (!this.sliders) return false;
  
    this.initedSlider = false;
    this.inited = [];
    this.setEvents();
  }
  
  setEvents() {
    this.checkWindow();
    
    window.addEventListener('resize', () => {
      this.checkWindow();
    })
  }
  
  checkWindow() {
    
    if (window.innerWidth < 768 && !this.inited.length) {
      this.initSliders();
      this.initedSlider = true;
  
    } else {
      this.destroySliders();
      this.initedSlider = false;
    }
  }
  
  initSliders() {
    this.sliders.forEach(item => {
      
      const slider = new Splide(item.querySelector(`[${this.settings.list}]`), {
        cover: true,
        perPage: 1,
        perMove: 1,
        updateOnMove : true,
        breakpoints: {
          767: {
            perPage: 1,
          }
        },
      });
      
      this.inited.push(this.mountSlider(slider));
    });
  }
  
  mountSlider(slider) {
    return slider.mount();
  }
  
  destroySliders() {
    if (!this.inited) return;
    
    this.inited.forEach(slider => {
      slider.destroy();
    })
  }
}
